module.exports = __webpack_public_path__ + "img/jlazhu.d757fb31.gif";